import LegalLayout from "./LegalLayout";

export default function PrivacyPolicy() {
  return (
    <LegalLayout title="Politique de confidentialité" updated="23 juillet 2026">
      <p>
        Chez <strong>Délices Mikaté Royal</strong>, nous accordons une grande importance à la protection de
        vos renseignements personnels. La présente politique explique quels renseignements nous
        recueillons, pourquoi, comment ils sont utilisés et comment nous les protégeons, conformément à
        la <em>Loi 25</em> (Loi modernisant des dispositions législatives en matière de protection des
        renseignements personnels) au Québec et à la <em>Loi sur la protection des renseignements
        personnels et les documents électroniques (LPRPDE)</em> au Canada.
      </p>

      <h2>1. Responsable de la protection des renseignements personnels</h2>
      <p>
        <strong>Délices Mikaté Royal</strong><br />
        Adresse&nbsp;: Sorel-Tracy (Québec), Canada<br />
        Courriel&nbsp;: <a href="mailto:contact@mikateroyal.com">contact@mikateroyal.com</a><br />
        Site Web&nbsp;: <a href="https://www.mikateroyal.com" target="_blank" rel="noreferrer">www.mikateroyal.com</a>
      </p>

      <h2>2. Renseignements que nous recueillons</h2>
      <p>Nous recueillons uniquement les renseignements strictement nécessaires à la fourniture de nos services&nbsp;:</p>
      <ul>
        <li><strong>Identité et coordonnées</strong>&nbsp;: nom, adresse courriel, numéro de téléphone, adresse de livraison.</li>
        <li><strong>Détails de commande</strong>&nbsp;: produits sélectionnés, quantités, mode de paiement préféré, messages.</li>
        <li><strong>Détails d&apos;événement</strong> (soumissions)&nbsp;: type d&apos;événement, date, nombre de personnes, commentaires.</li>
        <li><strong>Données de navigation</strong>&nbsp;: cookies techniques et données d&apos;utilisation (voir notre <a href="/politique-cookies">Politique sur les cookies</a>).</li>
      </ul>

      <div className="callout">
        <p><strong>Aucune information bancaire n&apos;est stockée sur notre site.</strong> Les paiements se font par virement Interac, PayPal, ou en argent comptant à la livraison. Nous ne demandons ni ne conservons aucune donnée de carte bancaire.</p>
      </div>

      <h2>3. Finalités de la collecte</h2>
      <p>Vos renseignements sont utilisés exclusivement pour&nbsp;:</p>
      <ul>
        <li>Traiter et livrer vos commandes;</li>
        <li>Préparer les soumissions d&apos;événements;</li>
        <li>Vous transmettre les confirmations et instructions de paiement;</li>
        <li>Répondre à vos questions (par courriel, formulaire ou via notre assistante virtuelle Nancy);</li>
        <li>Améliorer nos services et la sécurité du site.</li>
      </ul>

      <h2>4. Consentement</h2>
      <p>
        En soumettant un formulaire de commande, vous consentez de manière libre, éclairée et manifeste à
        la collecte et à l&apos;utilisation de vos renseignements aux fins décrites ci-dessus. Vous pouvez
        retirer votre consentement à tout moment en nous écrivant à
        <a href="mailto:contact@mikateroyal.com"> contact@mikateroyal.com</a>.
      </p>

      <h2>5. Communication à des tiers</h2>
      <p>
        Nous ne vendons jamais vos renseignements. Nous les partageons uniquement avec des prestataires
        strictement nécessaires à l&apos;exécution du service&nbsp;:
      </p>
      <ul>
        <li><strong>Resend</strong>&nbsp;: envoi des confirmations et soumissions par courriel;</li>
        <li><strong>Fournisseurs de messagerie / IA</strong> (Anthropic Claude via Emergent) pour l&apos;assistante Nancy;</li>
        <li><strong>Hébergeur</strong>&nbsp;: hébergement sécurisé du site et des données.</li>
      </ul>
      <p>Ces prestataires sont soumis à des obligations contractuelles de confidentialité et de sécurité.</p>

      <h2>6. Conservation et sécurité</h2>
      <p>
        Vos données sont conservées uniquement pendant la durée nécessaire à la finalité pour laquelle
        elles ont été recueillies (généralement 24 mois après votre dernière commande), ou plus longtemps
        si la loi l&apos;exige (obligations comptables et fiscales).
      </p>
      <p>
        Les données sont transmises sur une connexion sécurisée <strong>HTTPS (TLS)</strong> et stockées
        dans une base de données à accès restreint. Nous appliquons des mesures organisationnelles et
        techniques raisonnables pour prévenir toute perte, accès non autorisé ou divulgation.
      </p>

      <h2>7. Vos droits</h2>
      <p>Conformément à la Loi 25 et à la LPRPDE, vous disposez des droits suivants&nbsp;:</p>
      <ul>
        <li><strong>Accès</strong>&nbsp;: obtenir la liste des renseignements que nous détenons à votre sujet;</li>
        <li><strong>Rectification</strong>&nbsp;: faire corriger un renseignement inexact ou incomplet;</li>
        <li><strong>Retrait du consentement</strong> et <strong>suppression</strong> de vos données;</li>
        <li><strong>Portabilité</strong>&nbsp;: recevoir vos données dans un format structuré et couramment utilisé;</li>
        <li><strong>Plainte</strong> auprès de la <a href="https://www.cai.gouv.qc.ca" target="_blank" rel="noreferrer">Commission d&apos;accès à l&apos;information du Québec</a> ou du <a href="https://www.priv.gc.ca" target="_blank" rel="noreferrer">Commissariat à la protection de la vie privée du Canada</a>.</li>
      </ul>
      <p>
        Pour exercer ces droits, écrivez-nous à <a href="mailto:contact@mikateroyal.com">contact@mikateroyal.com</a>.
        Nous vous répondrons dans un délai maximal de 30 jours.
      </p>

      <h2>8. Témoins de connexion (cookies)</h2>
      <p>
        Notre site utilise des témoins (cookies) nécessaires au bon fonctionnement du site ainsi que,
        lorsque applicable, des cookies de mesure d&apos;audience afin d&apos;améliorer l&apos;expérience
        utilisateur.
      </p>
      <p>
        Les visiteurs peuvent gérer leurs préférences grâce à la bannière de consentement affichée lors
        de leur première visite.
      </p>
      <p>
        Pour plus d&apos;informations, veuillez consulter notre
        <a href="/politique-cookies"> Politique sur les cookies</a>.
      </p>

      <h2>9. Modifications</h2>
      <p>
        Cette politique peut être mise à jour à tout moment. La date de la dernière modification est
        indiquée en haut du document.
      </p>

      <h2>10. Nous joindre</h2>
      <p>
        <strong>Délices Mikaté Royal</strong><br />
        Courriel&nbsp;: <a href="mailto:contact@mikateroyal.com">contact@mikateroyal.com</a><br />
        Site Web&nbsp;: <a href="https://www.mikateroyal.com" target="_blank" rel="noreferrer">www.mikateroyal.com</a>
      </p>
    </LegalLayout>
  );
}
